interface ICheckMinMax {
  value: string
  min?: string | number
  max?: string | number
}
export const checkMinMax = ({ value, min, max }: ICheckMinMax): string => {
  if (min !== undefined && value !== undefined && value !== '') {
    if (Number(value) < Number(min)) {
      if (Number(min) === 0) {
        return String(Math.abs(Number(value)))
      } else {
        return ''
      }
    }
  }

  if (max !== undefined && value !== undefined && value !== '') {
    if (Number(value) > Number(max)) {
      return ''
    }
  }

  return value

  return ''
}
